module.exports = __webpack_public_path__ + "img/furgon.e52e990f.svg";